import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 1.69824L10 5.03158V8.99995H14V5.03158L18 1.69824L22 5.03158V22H15.5V18.5C15.5 16.567 13.933 15 12 15C10.067 15 8.5 16.567 8.5 18.5V22H2V5.03158L6 1.69824ZM20 8.99995V5.96833L18 4.30166L16 5.96833V8.99995H20ZM4 8.99995H8V5.96833L6 4.30166L4 5.96833V8.99995Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 17C11.1716 17 10.5 17.6716 10.5 18.5V22H13.5V18.5C13.5 17.6716 12.8284 17 12 17Z"}}]};

const Palace4Filled = Vue.extend<IconProps>({
  name: 'Palace4FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'palace-4-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Palace4Filled;
